import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader } from "@/components/site/Blocks";
import { UniversalLeadForm as LeadForm } from "@/components/site/UniversalLeadForm";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/solicitar/")({
  head: () =>
    buildHead({
      title: "Solicitar un Préstamo DSCR o para Inversionistas | Simply Approved",
      description:
        "Inicie su solicitud de préstamo DSCR o con fines comerciales para propiedades de inversión. Comparta su escenario y un oficial de préstamos con licencia lo revisará, generalmente el mismo día hábil.",
      url: "/es/solicitar",
      locale: "es",
      keywords:
        "solicitud préstamo DSCR, solicitud préstamo inversionista, préstamo con fines comerciales, aplicar préstamo DSCR, solicitud financiamiento propiedad de inversión, solicitud préstamo alquiler",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Solicitar", url: "/es/solicitar" },
      ],
      service: { name: "Solicitud de préstamos DSCR y con fines comerciales" },
      faqs: [
        {
          q: "¿Es esta una solicitud de préstamo completa?",
          a: "No. Es una solicitud corta de pre-calificación, no una solicitud de préstamo bajo TILA/RESPA. No solicitamos número de seguro social, fecha de nacimiento ni ingresos personales, y enviarla no es una oferta de crédito.",
        },
        {
          q: "¿Qué tan rápido responde un oficial de préstamos?",
          a: "Un oficial de préstamos con licencia revisa cada escenario y generalmente responde el mismo día hábil con los documentos necesarios para avanzar.",
        },
        {
          q: "¿Prestan en viviendas ocupadas por el propietario?",
          a: "No. Simply Approved Mortgages gestiona préstamos con fines comerciales para propiedades de inversión no ocupadas por el propietario únicamente.",
        },
      ],
    }),
  component: Apply,
});

function Apply() {
  return (
    <SiteShell>
      <PageHero
        eyebrow="Solicitar"
        title="Inicie su solicitud de préstamo DSCR o para inversionistas."
        subtitle="Complete el formulario a continuación. Un oficial de préstamos revisará su escenario y se comunicará con los siguientes pasos."
      />
      <Section>
        <div className="mx-auto max-w-3xl">
          <SectionHeader title="Cuéntenos sobre su escenario" />
          <div className="mt-6 rounded-2xl border border-border bg-card p-6 shadow-sm sm:p-8">
            <LeadForm />
          </div>
          <p className="mt-4 text-xs text-muted-foreground">
            Al enviar, usted autoriza a Simply Approved Mortgages LLC a contactarlo por teléfono,
            correo electrónico o mensaje de texto sobre su solicitud. Los mensajes y correos pueden
            enviarse usando sistemas automatizados. No se requiere consentimiento para comprar bienes
            o servicios.
          </p>
        </div>
      </Section>
    </SiteShell>
  );
}
